// extracted by mini-css-extract-plugin
export default {"link":"BaseIconLink-WWzwf__link","icon":"BaseIconLink-hL5Kf__icon"};